<template>
  <div>
    <header-component />

    <div class="helpMain">
      <div class="helpOne">
        <div class="w1300">
          <!-- 面包屑 -->
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item> 帮助与支持</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- 面包屑 结束-->

          <div class="box">
            <div class="tle">
              <h2 class="tit-46 fw700">您需要我们提供哪种服务？</h2>
            </div>
          </div>
        </div>
      </div>

      <div class="helpTwo">
        <div class="w1300">
          <div class="box">
            <div class="tabs">
              <el-tabs
                tab-position="left"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane name="first">
                  <div slot="label" class="">
                    <div class="flex-c">
                      <i class="icBox flex-cc mr-10">
                        <el-image
                          :src="require('@/assets/helpTwo-tab-icon1.png')"
                        ></el-image>
                      </i>
                      <span class="tit-24">业务合作</span>
                    </div>
                  </div>

                  <div class="formlist formOne">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                      <el-form-item label=" " prop="name">
                        <el-input
                          v-model="ruleForm.name"
                          placeholder="请填写联系人"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label=" " prop="tel">
                        <el-input
                          v-model="ruleForm.tel"
                          placeholder="请填写联系电话"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label=" " prop="email">
                        <el-input
                          v-model="ruleForm.email"
                          placeholder="请填写邮箱"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label=" " prop="company">
                        <el-input
                          v-model="ruleForm.company"
                          placeholder="请填写公司名称"
                        ></el-input>
                      </el-form-item>

                      <!-- 行业 -->
                      <el-form-item label=" " prop="industry" class="hangye">
                        <el-select
                          v-model="ruleForm.industry"
                          placeholder="请选择行业"
                        >
                          <el-option label="请选择行业" value=""></el-option>
                          <el-option
                            label="迎宾接待"
                            value="welcome_reception"
                          ></el-option>
                          <el-option label="酒店" value="hotel"></el-option>
                          <el-option
                            label="教育科研"
                            value="education_research"
                          ></el-option>
                          <el-option
                            label="养老陪伴"
                            value="elderly_care"
                          ></el-option>
                          <el-option label="医疗" value="medical"></el-option>
                          <el-option
                            label="娱乐展示"
                            value="entertainment_display"
                          ></el-option>
                          <el-option
                            label="物业安防"
                            value="property_security"
                          ></el-option>
                          <el-option label="餐饮" value="catering"></el-option>
                        </el-select>
                      </el-form-item>

                      <!-- 客户类别 -->
                      <el-form-item
                        label=" "
                        prop="customerType"
                        class="kehuleixing"
                      >
                        <el-select
                          v-model="ruleForm.customerType"
                          placeholder="请选择客户类别"
                        >
                          <el-option
                            label="请选择客户类别"
                            value=""
                          ></el-option>
                          <el-option label="业主" value="owner"></el-option>
                          <el-option
                            label="集成商"
                            value="integrator"
                          ></el-option>
                          <el-option label="代理商" value="agent"></el-option>
                          <el-option
                            label="渠道商"
                            value="distributor"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item
                        label=""
                        prop="content"
                        style="width: 100%"
                        class="textForm"
                      >
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="ruleForm.content"
                          placeholder="给我们留言"
                        ></el-input>
                      </el-form-item>

                      <el-form-item class="sub">
                        <el-button
                          type="primary"
                          @click="submitForm('ruleForm')"
                        >
                          提交留言
                        </el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="second">
                  <div slot="label">
                    <div class="flex-c">
                      <i class="icBox mr-10">
                        <el-image
                          class="flex-cc"
                          :src="require('@/assets/helpTwo-tab-icon2.png')"
                        ></el-image>
                      </i>
                      <span class="tit-24">售后咨询</span>
                    </div>
                  </div>

                  <div class="formlist formTwo">
                    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2">
                      <el-form-item label=" " prop="order">
                        <el-input
                          v-model="ruleForm2.order"
                          placeholder="订单编号"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="" prop="name">
                        <el-input
                          v-model="ruleForm2.name"
                          placeholder="请填写联系人"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label=" " prop="tel">
                        <el-input
                          v-model="ruleForm2.tel"
                          placeholder="请填写联系电话"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label=" " prop="email">
                        <el-input
                          v-model="ruleForm2.email"
                          placeholder="请填写邮箱"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label=" "
                        prop="content"
                        style="width: 100%"
                        class="textForm"
                      >
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="ruleForm2.content"
                          placeholder="问题描述"
                        ></el-input>
                      </el-form-item>

                      <el-form-item class="upload">
                        <span>上传截图</span>
                        <!-- action="https://jsonplaceholder.typicode.com/posts/" -->
                        <el-upload
                          ref="shangtu"
                          :headers="headers"
                          :action="url"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove"
                          :on-success="shangchuncg"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible">
                          <img width="100%" :src="dialogImageUrl" alt="" />
                        </el-dialog>
                      </el-form-item>

                      <el-form-item class="sub">
                        <el-button
                          type="primary"
                          @click="submitForm2('ruleForm2')"
                        >
                          提交留言
                        </el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>

            <div class="zixun_code">
              <!-- <span>售前咨询</span> -->
              <div class="imgBox">
                <img src="@/assets/shouqian_zixun.png" alt="售前咨询" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-component />
  </div>
</template>

<script>
// 引用公用组件
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";

export default {
  name: "HelpIndex",

  components: {
    headerComponent,
    footerComponent,
  },
  data() {
    return {
      activeName: "first",
      url: "",
      headers: {},
      ruleForm: {
        name: "",
        tel: "",
        email: "",
        industry: "", // 行业
        customerType: "", // 客户类别

        company: "",
        address: "",
        content: "",
      },
      ruleForm2: {
        order: "",
        name: "",
        tel: "",
        email: "",
        content: "",
      },

      // 表单验证
      rules: {
        name: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        tel: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          { required: true, message: "请填写邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],

        company: [
          { required: true, message: "请填写公司名称", trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请选择行业", trigger: "change" },
        ],
        customerType: [
          { required: true, message: "请选择客户类别", trigger: "change" },
        ],

        content: [{ message: "请填写留言内容", trigger: "blur" }],
      },
      // 表单验证
      rules2: {
        order: [{ required: true, message: "请填写订单编号", trigger: "blur" }],
        name: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        tel: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          { required: true, message: "请填写邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],

        content: [
          { required: true, message: "请填写问题描述", trigger: "blur" },
        ],
      },

      // 上传
      dialogImageUrl: "",
      dialogVisible: false,
      shu: [],
      // 上传视频
      videoForm: {
        showVideoPath: "",
        videoPath: "",
      },
      videoFlag: false,
      a: [],
    };
  },
  created() {
    var that = this;
    this.url = this.$url + "&k=wenjian";
    setTimeout(function() {
      if (typeof that.value == "string") {
        that.shu = [
          {
            url: that.value,
          },
        ];
        that.a.push(that.value);
      } else if (typeof that.value == "object") {
        that.a = that.value;
        for (var i in that.value) {
          that.shu.push({
            url: that.value[i],
          });
        }
      }
    }, 500);
    var yonghu = this.$qu("yonghux");
    this.headers.kouling = yonghu.kouling;
  },

  methods: {
    handleClick(tab, event) {},

    // 上传
    shangchuncg(file, fileList) {
      if (file.shi == 1) {
        this.a.push(file.shu.url);
      } else {
        this.$xiaoxi(file.shu, 0);
      }
    },

    handleRemove(file, fileList) {
      var that = this;
      that.a = that.$refs.shangtu.uploadFiles;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    submitForm(formName) {
      var that = this;
      console.log(that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // 模拟提交表单
          // setTimeout(() => {
          //   this.$message.success("提交成功");
          // }, 1000);
          that.$post("k=help&c=hezuo", that.ruleForm, function(s) {
            if (s.shi == 1) {
              that.$message.success("提交成功");
              // 清空表单
              that.ruleForm = {};
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitForm2(formName) {
      var that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // 模拟提交表单
          setTimeout(() => {
            that.ruleForm2.tu = that.a;
            that.$post("k=help&c=Shouhou", that.ruleForm2, function(s) {
              if (s.shi == 1) {
                that.$message.success("提交成功");
              } else {
                that.$message.error(s.shu);
              }
            });
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.helpMain {
  .helpOne {
    padding: 0.3rem 0 0.6rem;
    .tle {
      margin-top: 0.7rem;
    }
  }

  .helpTwo {
    padding: 0.7rem 0 1.2rem;
    background: #f9f9f9;

    /deep/ .el-tabs__content {
      width: 65%;
      margin-left: auto;
    }

    /deep/ .formlist {
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      .el-form-item {
        width: 48%;
        display: flex;
        margin-bottom: 0.4rem;

        .el-form-item__label {
          position: absolute;
          z-index: 1;
        }

        .el-select {
          width: 100%;
        }

        .el-form-item__content {
          width: 100%;
          .el-input__inner {
            background: none;
            border: 0;
            border-radius: 0;
            border-bottom: 1px solid rgba(153, 153, 153, 0.3);
            color: #333;
            &::placeholder {
              color: #333333;
            }
          }

          .el-textarea__inner {
            background: none;
            padding: 0.1rem 15px;
            border-radius: 0;
            border: 0;
            border-bottom: 1px solid rgba(153, 153, 153, 0.3);

            color: #333;
            &::placeholder {
              color: #333333;
            }
          }
        }

        .el-cascader {
          width: 100%;
        }

        &.el-form-item.is-error .el-input__inner,
        &.el-form-item.is-error .el-input__inner:focus {
          border-color: #f56c6c;
        }
      }

      .textForm {
        margin-top: 1rem;
      }

      .sub {
        width: 100%;
        margin-top: 1rem;
        button {
          padding: 0.14rem 1rem;
          background: linear-gradient(88deg, #001ff5 0%, #41b9e0 100%);
          border-radius: 100px;
        }
      }

      &.formTwo {
        .textForm {
          margin-top: 0rem;
        }

        .sub {
          margin-top: 0.5rem;
        }
      }
    }

    .box {
      position: relative;
      .zixun_code {
        width: 2rem;
        position: absolute;
        left: 0;
        bottom: 25%;
        text-align: center;
        .imgBox {
          width: 100%;
          margin-top: 0.1rem;

          img {
            width: 100%;
          }
        }
      }
    }
  }

  // 修改饿了么tabs样式
  /deep/ .tabs {
    .el-tabs--left,
    .el-tabs--right,
    .el-tabs__nav-wrap,
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs::after {
      content: "";
      display: block;
      height: 0;
      clear: both;
    }
    .el-tabs__nav-wrap.is-left::after {
      display: none;
    }
    .el-tabs__active-bar.is-left {
      display: none;
    }

    .el-tabs__item {
      margin-top: 0.5rem;
      height: auto;
      line-height: initial;
      padding: 0.2rem 0.35rem;
      border-radius: 100px;
      .el-image {
        filter: brightness(0);
        -webkit-filter: brightness(0);
      }

      &:hover {
        color: #001ff5;
        .el-image {
          filter: brightness(1);
          -webkit-filter: brightness(1);
        }
      }

      &.is-active {
        box-shadow: 0rem 0rem 0.59rem 0rem rgba(156, 156, 156, 0.18);
        background: #ffffff;
        color: #001ff5;
        .el-image {
          filter: brightness(1);
          -webkit-filter: brightness(1);
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .helpMain {
    .helpOne {
      .tle {
        h2 {
          font-size: var(--font40);
        }
      }
    }

    /deep/ .helpTwo {
      .formlist {
        .el-form-item {
          width: 100%;
        }

        .textForm {
          margin-top: 0.4rem;
        }
        .sub {
          margin-top: 0.1rem;

          button {
            padding: 0.15rem 0.5rem;
          }
        }
      }

      .tabs {
        .is-left {
          float: none;
        }
        .el-tabs__nav {
          display: flex;

          .el-tabs__item {
            margin-top: 0;
            .icBox {
              width: 0.5rem;
              margin-right: 0.2rem;
            }

            span {
              font-size: var(--font20);
            }
          }
        }
      }

      .el-tabs__content {
        width: 100%;
        margin-top: 0.4rem;
      }

      .box .zixun_code {
        margin: auto;
        position: relative;
        bottom: 0;
        width: 3rem;
      }
    }
  }
}
</style>
